import { render, staticRenderFns } from "./vcharts.vue?vue&type=template&id=5b3fb764&"
import script from "./vcharts.vue?vue&type=script&lang=js&"
export * from "./vcharts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports